import React from 'react';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface ReceiptModalProps {
    open: boolean;
    onClose: () => void;
    receiptData: any;
    setReceiptData: (data: any) => void;
    confirming: boolean;
    onConfirm: () => void
    newItemName: string;
    setNewItemName: (name: string) => void;
    newItemPrice: string;
    setNewItemPrice: (price: string) => void;
}

const ReceiptModal: React.FC<ReceiptModalProps> = ({
                                                       open,
                                                       onClose,
                                                       receiptData,
                                                       setReceiptData,
                                                       confirming,
                                                       onConfirm,
                                                   }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Patvirtinti kvito informaciją</DialogTitle>
            <DialogContent>
                {receiptData && (
                    <Box sx={{ mt: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Data</Typography>
                        <Typography variant="body2" sx={{ mb: 1 }}>{receiptData.purchase_date || receiptData.purchaseDate}</Typography>

                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Vieta</Typography>
                        <Typography variant="body2">{receiptData.store_name || receiptData.storeName}</Typography>
                        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>{receiptData.store_address || receiptData.storeAddress}</Typography>

                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Prekės</Typography>
                        <List dense>
                            {(receiptData.items || []).map((it: any, idx: number) => (
                                <ListItem
                                    key={idx}
                                    secondaryAction={
                                        <IconButton edge="end" aria-label="delete" onClick={() => {
                                            const updated = { ...receiptData };
                                            updated.items = (updated.items || []).filter((_: any, i: number) => i !== idx);
                                            setReceiptData(updated);
                                        }}>
                                            <DeleteIcon />
                                        </IconButton>
                                    }
                                >
                                    <ListItemText primary={`${it.name} — ${it.price}`} />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={confirming}>Atšaukti</Button>
                <Button
                    variant="contained"
                    disabled={confirming}
                    onClick={onConfirm}
                >
                    {confirming ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CircularProgress size={20} color="inherit" />
                            Patvirtinama...
                        </Box>
                    ) : (
                        'Patvirtinti'
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReceiptModal;